import { LANDING_PAGE_GET_SUMMARY_START, LANDING_PAGE_GET_SUMMARY_SUCCESS, LANDING_PAGE_GET_SUMMARY_FAIL } from './actionTypes';

import axios from '../../util/axios-portals';

const getLandingPageSummaryFail = (error) => {
    return {
        type: LANDING_PAGE_GET_SUMMARY_FAIL, 
        error
    };
}

const getLandingPageSummarySuccess = (data) => {
    return {
        type: LANDING_PAGE_GET_SUMMARY_SUCCESS, 
        landingPageSummary: data
    };
}

const getLandingPageSummaryStart = () => {
    return {
        type: LANDING_PAGE_GET_SUMMARY_START
    };
}

export const getLandingPageSummary = (token) => {
    return (dispatch) => {
        dispatch(getLandingPageSummaryStart());

        axios.get(`/actions`, {
            headers: {
                'Authorization': `Bearer ${token}`, 
                'Accept': 'application/json'
            }
        })
        .then(response => dispatch(getLandingPageSummarySuccess(response.data)))
        .catch(err => dispatch(getLandingPageSummaryFail(err)));
    };
}